import React from 'react';
import { Helmet } from 'react-helmet';

const FAQ = () => (
  <div
    style={{
      padding: '1rem',
      lineHeight: 1.6,
      textAlign: 'left',
      maxWidth: '820px',
      margin: '0 auto'
    }}
  >
    {/* SEO */}
    <Helmet>
      <title>よくある質問（FAQ） | トレイルランニングシミュレータ</title>
      <meta
        name="description"
        content="TrailRunSim の FAQ。GPX読み込み、ITRA指数、ペース計算、シミュレーション精度などを解説。"
      />
      <meta
        name="keywords"
        content="トレラン, トレイルランニング, シミュレーター, GPX, ITRA, FAQ"
      />
    </Helmet>

    {/* 🍏 タイトル */}
    <h2>よくある質問（FAQ）</h2>

    <p style={{ margin: '0.6rem 0 1.2rem', color: '#444' }}>
      TrailRunSim のご利用に関する、よくあるご質問とその回答をまとめました。
      GPXファイルの読み込み、ITRAパフォーマンスインデックス、予測精度の目安、利用上の注意点など、
      初めての方にも分かりやすく解説しています。
    </p>

    {/* 🍏 Q1 */}
    <div
      style={{
        marginTop: '1.6rem',
        padding: '1rem',
        background: 'rgba(255,255,255,0.55)',
        borderRadius: '12px'
      }}
    >
      <h3 style={{ marginTop: 0 }}>Q1. GPXファイルがうまく読み込めません。どうすればいいですか？</h3>
      <p style={{ margin: '0.4rem 0 0.8rem', color: '#444' }}>
        対応しているGPXファイルは標準的な形式のものです。ファイルの形式や内容が異なる場合は読み込みに失敗することがあります。
        別のGPXファイルや、レース主催者が配布している公式データを試してください。
      </p>
    </div>

    {/* 🍏 Q2 */}
    <div
      style={{
        marginTop: '1.6rem',
        padding: '1rem',
        background: 'rgba(255,255,255,0.55)',
        borderRadius: '12px'
      }}
    >
      <h3 style={{ marginTop: 0 }}>Q2. ITRAパフォーマンスインデックスとは何ですか？</h3>
      <p style={{ margin: '0.4rem 0 0.8rem', color: '#444' }}>
        ITRAパフォーマンスインデックスは国際トレイルランニング協会が定めるランナーの走力指標です。
        本シミュレータはこの指標を元に持久力の計算を行います。
      </p>
    </div>

    {/* 🍏 Q3 */}
    <div
      style={{
        marginTop: '1.6rem',
        padding: '1rem',
        background: 'rgba(255,255,255,0.55)',
        borderRadius: '12px'
      }}
    >
      <h3 style={{ marginTop: 0 }}>Q3. シミュレーション結果はどの程度正確ですか？</h3>
      <p style={{ margin: '0.4rem 0 0.8rem', color: '#444' }}>
        予測結果はあくまで目安です。コース状況、天候、体調などにより大きく変わります。
        獲得標高が大会サイトと大きく異なる場合は、GPXファイルの精度が低い可能性があります。
        他のGPXファイルを試してみてください。
      </p>
    </div>

    {/* 🍏 Q4 */}
    <div
      style={{
        marginTop: '1.6rem',
        padding: '1rem',
        background: 'rgba(255,255,255,0.55)',
        borderRadius: '12px'
      }}
    >
      <h3 style={{ marginTop: 0 }}>Q4. 無料で使えますか？</h3>
      <p style={{ margin: '0.4rem 0 0.8rem', color: '#444' }}>
        はい、本シミュレータは無料でご利用いただけます。
      </p>
    </div>

    {/* 🍏 Q5 */}
    <div
      style={{
        marginTop: '1.6rem',
        padding: '1rem',
        background: 'rgba(255,255,255,0.55)',
        borderRadius: '12px'
      }}
    >
      <h3 style={{ marginTop: 0 }}>Q5. 利用にあたって注意点はありますか？</h3>
      <p style={{ margin: '0.4rem 0 0.8rem', color: '#444' }}>
        公式の大会ルールや関門時間を最優先してください。本ツールの情報のみで判断しないようご注意ください。
      </p>
    </div>

  </div>
);

export default FAQ;
